import { render } from "./IssuesReportButton.vue?vue&type=template&id=0e684234"
import script from "./IssuesReportButton.vue?vue&type=script&lang=js"
export * from "./IssuesReportButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__